"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_OPTIONS = exports.DEPARTMENT_OPTIONS = exports.TABLE_HEAD_CELLS = void 0;
exports.TABLE_HEAD_CELLS = [
    {
        label: "Name",
        id: "username",
        numeric: false,
        disablePadding: false,
    },
    {
        id: "department",
        label: "Area",
        numeric: false,
        disablePadding: false,
    },
    {
        id: "email",
        label: "E-mail",
        numeric: false,
        disablePadding: false,
    },
    {
        id: "roles",
        label: "Roles",
        numeric: false,
        disablePadding: false,
    },
    {
        id: "delete",
        label: "",
        numeric: false,
        disablePadding: false,
    },
];
exports.DEPARTMENT_OPTIONS = [
    {
        value: "planning_and_scheduling",
        label: "Planning and Scheduling",
    },
    {
        value: "process_engineering",
        label: "Proccess Engineering",
    },
    {
        value: "feedstock_trading",
        label: "Feedstock Trading",
    },
];
exports.ROLE_OPTIONS = [
    {
        value: "planner",
        label: "Planner",
    },
    {
        value: "admin",
        label: "Admin",
    },
    {
        value: "trader",
        label: "Trader",
    },
    {
        value: "engineer",
        label: "Engineer",
    },
];
